<template>
    <div id="addModal" class="modal-open" data-open="modal">
        <div
            class="fixed inset-0 top-0 left-0 right-0 z-50 flex items-center justify-center w-full h-full p-4 overflow-x-hidden overflow-y-auto themeBgModalOverlay">
            <div class="relative w-full h-auto themeModalContainer md:h-auto"
                :class="widthClass ? widthClass : 'max-w-6xl'">
                <div class="relative rounded-sm themeCards hrm_modal_container">
                    <!-- Modal header -->
                    <div class="flex items-center justify-between p-4 rounded-t  hrm_modal_header">
                        <h3 class="text-base font-semibold text-gray-800 dark:text-gray-300">
                            {{ modalData.title }}
                        </h3>
                        <button type="button"
                            class="hrm_modal_close_button themeModalClose w-7 h-7 flex items-center justify-center"
                            @click="modalData.isAdd = false; close();">
                            <Icon icon="maki:cross" width="1.2em" height="1.2em" />
                        </button>
                    </div>
                    <component :is="currentComponent" :modalData="modalData" @close="close" @refresh="refresh" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineAsyncComponent } from "vue";
import { TrashIcon, XCircleIcon } from "@heroicons/vue/24/solid";
import { defineProps, defineEmits } from "vue";
import { Icon } from "@iconify/vue";

// Use defineProps to access props
const props = defineProps();
const compName = ref(props.compName);
const modalData = ref(props.modalData);
const widthClass = ref(props.widthClass);

// Use defineEmits to access emit function
const emit = defineEmits();

// Define close method
const close = () => {
    emit("close");
};

const refresh = () => {
    emit("refresh");
};

const components = {
    // Organization
    OrganizationCompanyAdd: defineAsyncComponent(() =>
        import("./../Organization/Companies/Add.vue")
    ),


    //Tenant All modals
    AddLead: defineAsyncComponent(() =>
        import("../Lead/Add.vue")
    ),
    ConvertLead: defineAsyncComponent(() =>
        import("../Tenant/Add.vue")
    ),

};
const currentComponent = ref(components[compName.value]);
</script>

<script>
// Define props and components for type inference
import { defineComponent } from "vue";
import { TrashIcon, XCircleIcon } from "@heroicons/vue/24/solid";

export default defineComponent({
    components: {
        TrashIcon,
        XCircleIcon,
    },
    props: {
        compName: {
            required: true,
            type: String,
        },
        modalData: {
            type: Object,
        },
        widthClass: {
            type: String
        }
    },
});
</script>
<style>
.hrm_modal_close_button {
    color: #2b2f30;
    transition: all .6s !important;
    border-radius: 100px;
}

.dark .hrm_modal_close_button {
    color: #757c83;
}

.dark .hrm_modal_close_button:hover {
    background-color: #363a3e;
}

.dark .hrm_modal_close_button:hover svg path {
    fill: #757c83 !important;
}
</style>